import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import RepoList from '../RepoList';
import GitStatLayout from '../GitStatistics/components/GitStatLayout';

const MainWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey = location.pathname.includes('projects') ? '2' : '1';

  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: 'Contributors',
      children: <GitStatLayout />,
    },
    {
      key: '2',
      label: 'Projects',
      children: <RepoList />,
    },
  ];

  const onTabChange = (key: string) => {
    navigate(key === '1' ? '/contributors/list' : '/projects');
  };

  return (
    <div style={{ position: 'fixed', width: '100%' }}>
    <Tabs
      type='card'
      defaultActiveKey={activeKey}
      items={tabItems}
      onChange={onTabChange}
    />
    </div>
  );
};

export default MainWrapper;
